import { api } from '@api'
import { useQuery } from '@tanstack/react-query'
import { Memory } from './usePaginateMemories'

const fetchMemoryById = async (id: string): Promise<Memory> => {
  const { data } = await api.get<Memory>(`/memories/${id}`)
  return data
}

export const useGetMemoryById = (id: string) => {
  return useQuery<Memory>({
    queryKey: ['memory', id],
    queryFn: () => fetchMemoryById(id),
    enabled: !!id,
  })
}
